import cx from 'classnames';
import AdSlot from 'mk2/containers/AdSlot/AdSlot';
import { BrandingProps } from 'mk2/pages/Page';
import React from 'react';
import styles from './AdSlotBranding.mscss';

interface OwnProps extends BrandingProps {}

type Props = OwnProps;

export class AdSlotBranding extends React.PureComponent<Props> {

    public render() {
        const { zone, targeting } = this.props;
        return (
            <React.Fragment> {/* <div className={styles.AdSlotBranding}> reduce DOM depth */}
                <AdSlot
                    className={cx(styles.AdSlotBranding__desktop)}
                    zone={`${zone} (Desktop)`}
                    targeting={targeting}
                    prefix="mk-branding"
                />
            </React.Fragment>
        );
    }
}
